import React from 'react';

// --- MUI Imports (Modern Way) ---
import Box from '@mui/material/Box';
import LinearProgress from '@mui/material/LinearProgress';

const Loader = () => {
    return (
        // Use the <Box> component with the 'sx' prop for direct styling
        <Box 
            sx={{
                position: 'fixed',
                top: 0,
                left: 0,
                zIndex: 1301,
                width: '100%',
                // The '& > * + *' selector applies margin to all direct children after the first one
                '& > * + *': {
                    mt: 2 // 'mt: 2' is the modern equivalent of 'marginTop: theme.spacing(2)'
                }
            }}
        >
            <LinearProgress color="primary" />
        </Box>
    );
};

export default Loader;